 // Элементы формы
 const taskTypeSelect = document.getElementById('taskType');
 const dataTypeSelect = document.getElementById('dataType');
 const modelDescriptionElement = document.getElementById('modelDescription');
 const dataDescriptionElement = document.getElementById('dataDescription');
 const accuracyInput = document.getElementById('accuracy');
 const resultsTableBody = document.querySelector('#resultsTable tbody');
 const loadingIndicator = document.getElementById('loadingIndicator');
 const comparisonResults = document.getElementById('comparisonResults');
 const descriptionText = document.getElementById('descriptionText');
 const mlModelDescription = document.getElementById('ml-modelDescription');
 const mlModelForm = document.getElementById('mlModelForm');
 
 // Кэширование описаний задач и типов данных
 const descriptionCache = {};

 // Функция для получения описания с бэкенда
function fetchDescription(requestType, key) {
 const cacheKey = `${requestType}-${key}`;
 if (descriptionCache[cacheKey]) {
     return Promise.resolve(descriptionCache[cacheKey]);
 }

 return fetch('/api/v1/nerdit/ml-comp/get_info', {
     method: 'POST',
     headers: { 'Content-Type': 'application/json' },
     body: JSON.stringify({ request_type: requestType, key: key }),
 })
 .then(response => response.json())
 .then(data => {
     if (!data || !data.description) {
         throw new Error('Описание не найдено');
     }
     descriptionCache[cacheKey] = data.description;
     return data.description;
 })
 .catch(error => {
     console.error('Ошибка при получении описания:', error);
     return ''; // Возвращаем пустую строку в случае ошибки
 });
}


 // Функция для обновления доступных типов данных в зависимости от типа задачи
function updateDataTypes(taskType) {
 // Получаем описание задачи и обновляем описание в UI
 fetchDescription('task', taskType).then(description => {
     if (description) {
         modelDescriptionElement.innerText = description;
         modelDescriptionElement.classList.add('show'); // Добавляем класс show для показа блока
         modelDescriptionElement.style.display = 'block';
     }
 });

 // Запрашиваем доступные типы данных для выбранной задачи с сервера
 fetch(`/api/v1/nerdit/ml-comp/get_info`, {
     method: 'POST',
     headers: { 'Content-Type': 'application/json' },
     body: JSON.stringify({ request_type: 'task', key: taskType })
 })
 .then(response => response.json())
 .then(data => {
     const availableDataTypes = data.availableDataTypes || []; // Защита от undefined

     // Обновляем список опций в select
     Array.from(dataTypeSelect.options).forEach(option => {
         if (availableDataTypes.includes(option.value)) {
             option.style.display = 'block';
         } else {
             option.style.display = 'none';
         }
     });

     // Устанавливаем первый доступный тип данных по умолчанию и принудительно обновляем описание
     if (availableDataTypes.length > 0) {
         dataTypeSelect.value = availableDataTypes[0];  // Выбираем первый доступный тип данных
         updateDataDescription(); // Обновляем описание типа данных для нового выбранного значения
     } else {
         dataTypeSelect.value = ''; // Очищаем выбор, если нет доступных типов данных
     }
 })
 .catch(error => {
     console.error('Ошибка при получении типов данных:', error);
 });
}

// Функция для обновления описания типа данных
function updateDataDescription() {
 const selectedDataType = dataTypeSelect.value;
 fetchDescription('data', selectedDataType).then(description => {
     if (description) {
         dataDescriptionElement.innerText = description;
         dataDescriptionElement.classList.add('show'); // Добавляем класс show для показа блока
         dataDescriptionElement.style.display = 'block';
     }
 });
}

// Проверяем, существует ли элемент dataTypeSelect на странице
if (dataTypeSelect) {
    // Обновляем описание типа данных при изменении выбора
    dataTypeSelect.addEventListener('change', function() {
        const selectedDataType = dataTypeSelect.value;
        fetchDescription('data', selectedDataType).then(description => {
            if (description) {
                dataDescriptionElement.innerText = description;
                dataDescriptionElement.classList.add('show'); // Добавляем класс show для показа блока
                dataDescriptionElement.style.display = 'block';
            }
        });
    });
} else {
    console.warn('Элемент dataTypeSelect не найден на странице.');
}


 // Проверяем, существует ли элемент taskTypeSelect на странице
if (taskTypeSelect) {
    // Обновляем описание задачи при изменении выбора
    taskTypeSelect.addEventListener('change', function() {
        const selectedTaskType = taskTypeSelect.value;
        updateDataTypes(selectedTaskType);
    });
} else {
    console.warn('Элемент taskTypeSelect не найден на странице.');
}


 // Проверяем, существует ли элемент accuracyInput на странице
if (accuracyInput) {
    // Валидация поля точности
    accuracyInput.addEventListener('input', function() {
        if (accuracyInput.value < 0 || accuracyInput.value > 1) {
            accuracyInput.setCustomValidity('Точность должна быть между 0 и 1.');
        } else {
            accuracyInput.setCustomValidity('');
        }
    });
} else {
    console.warn('Элемент accuracyInput не найден на странице.');
}


 // Показать индикатор загрузки
 function showLoading() {
     loadingIndicator.style.display = 'block';
 }

 // Скрыть индикатор загрузки
 function hideLoading() {
     loadingIndicator.style.display = 'none';
 }

 // Кэширование результатов
 const cache = {};

 // Функция для отправки данных на сервер и получения моделей
 function fetchData(requestData) {
     const cacheKey = JSON.stringify(requestData);
     if (cache[cacheKey]) {
         return Promise.resolve(cache[cacheKey]);
     }

     return fetch('/api/v1/nerdit/ml-comp/compare_models', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify(requestData),
     })
     .then(response => response.json())
     .then(data => {
         cache[cacheKey] = data;
         return data;
     });
 }

 // Проверяем, существует ли элемент mlModelForm на странице
if (mlModelForm) {
    // Обработка формы
    mlModelForm.addEventListener('submit', function(event) {
        event.preventDefault();
        showLoading();

        // Получаем значения введённых пользователем данных
        const taskType = taskTypeSelect.value;
        const dataType = dataTypeSelect.value;
        const accuracy = accuracyInput.value;
        const gpuSupport = document.getElementById('gpuSupport').value;
        const priority = document.getElementById('priority').value;

        // Формируем данные для отправки на бэкенд
        const requestData = {
            task_type: taskType,
            data_type: dataType,
            required_accuracy: parseFloat(accuracy),
            gpu_support: gpuSupport === "true",
            priority: priority
        };

        fetchData(requestData)
        .then(data => {
            hideLoading();
            resultsTableBody.innerHTML = '';

            // Если бэкенд вернул пустой массив
            if (data.length === 0) {
                const row = document.createElement('tr');
                row.innerHTML = `<td colspan="5">Нет подходящих моделей</td>`;
                resultsTableBody.appendChild(row);
            } else {
                // Заполняем таблицу результатами
                data.forEach(model => {
                    const row = document.createElement('tr');
                    row.innerHTML = `
                        <td data-label="Модель"><a href="#" class="model-link" data-model-name="${model.model}" data-description="${model.description}">${model.model}</a></td>
                        <td data-label="Время обучения">${model.training_time}</td>
                        <td data-label="Размер датасета">${model.dataset_size}</td>
                        <td data-label="Фреймворки">${model.recommended_frameworks.join(', ')}</td>
                        <td data-label="Оценка (Рейтинг)">${model.score.toFixed(2)}</td>
                    `;
                    resultsTableBody.appendChild(row);
                });

                // Объект для хранения кэшированных результатов
                const modelDescriptionCache = {};

                // Добавляем обработчик кликов для показа описания
                document.querySelectorAll('.model-link').forEach(link => {
                    link.addEventListener('click', async function(event) {
                        event.preventDefault(); // Отменяем стандартное поведение ссылки

                        const description = this.getAttribute('data-description'); // Получаем описание модели
                        const modelName = this.getAttribute('data-model-name');
                        const descriptionText = document.getElementById('descriptionText'); // Элемент для текста описания
                        const mlModelDescription = document.getElementById('ml-modelDescription'); // Элемент с блоком описания
                        const detailedDescriptionBtn = document.getElementById('detailedDescriptionBtn');

                        // Проверяем, есть ли данные в кэше
                        if (modelDescriptionCache[modelName]) {
                            descriptionText.innerHTML = modelDescriptionCache[modelName];  // Используем кэшированные данные
                            Prism.highlightAll();  // Применяем подсветку к коду
                            return;
                        }

                        descriptionText.innerText = description; // Устанавливаем описание
                        mlModelDescription.style.display = 'block'; // Показываем блок с описанием

                        // Плавное появление: сначала убираем класс, если есть, потом добавляем
                        mlModelDescription.classList.remove('fade');
                        setTimeout(() => mlModelDescription.classList.add('show'), 100); // Добавляем класс для анимации появления
                        // Показать кнопку "Получить подробное описание"
                        detailedDescriptionBtn.style.display = 'inline-block';

                        // Добавляем обработчик нажатия на кнопку для получения подробного описания с сервера
                        detailedDescriptionBtn.onclick = async function() {
                            // Деактивируем кнопку и показываем индикатор загрузки
                            detailedDescriptionBtn.disabled = true;
                            loadingIndicator.style.display = 'block';

                            try {
                                // Проверяем снова, вдруг кэш появился, пока кнопка нажималась
                                if (modelDescriptionCache[modelName]) {
                                    descriptionText.innerHTML = modelDescriptionCache[modelName];  // Используем кэшированные данные
                                    Prism.highlightAll();  // Применяем подсветку к коду
                                    return;
                                }
                                const response = await fetch('/api/v1/nerdit/ml-comp/get_model_desc', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ modelName: modelName })  // Отправляем имя модели
                                });

                                if (!response.ok) {
                                    throw new Error('Ошибка при получении описания модели');
                                }

                                const data = await response.json();
                                descriptionText.innerHTML = data.detailedDescription; 
                                // Сохраняем результат в кэше
                                modelDescriptionCache[modelName] = data.detailedDescription;
                                Prism.highlightAll();
                            } catch (error) {
                                descriptionText.innerText = 'Ошибка при загрузке подробного описания: ' + error.message;
                            } finally {
                                // Активируем кнопку и скрываем индикатор загрузки после завершения запроса
                                detailedDescriptionBtn.disabled = false;
                                detailedDescriptionBtn.style.display = 'none';
                                loadingIndicator.style.display = 'none';
                            }
                        };
                    });
                });
            }
        
            // Показываем результаты сравнения
            comparisonResults.classList.add('fade');
            setTimeout(() => comparisonResults.classList.add('show'), 100);
            comparisonResults.style.display = 'block';
        })
        .catch(error => {
            hideLoading();
            console.error('Ошибка:', error);
            alert('Произошла ошибка при подключении к серверу.');
        });
    });
}

 // Инициализация с первого выбора задачи
 document.addEventListener('DOMContentLoaded', function() {
    if (taskTypeSelect) {
     updateDataTypes(taskTypeSelect.value);
    }
 });